export const numberFormats = {}

export const dateTimeFormats = {
    short: {
        year: 'numeric', month: 'short', day: 'numeric',
    },
    long: {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
    },
    full: {
        weekday: 'long',
        year: 'numeric', month: 'short', day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    },
    time: {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
    },
}
